import { Link } from "react-router-dom";
import { IoCompassOutline } from "react-icons/io5";

export default function NotFound() {
  return (
    <div style={page}>
      <IoCompassOutline size={56} style={{ color: "var(--text-muted)" }} />
      <h1 style={heading}>Page not found</h1>
      <p style={body}>
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link to="/" style={homeLink}>Back to GatherYou</Link>
    </div>
  );
}

const page = {
  minHeight: "70vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "24px 24px calc(90px + env(safe-area-inset-bottom))",
  background: "var(--bg-page)",
};

const heading = {
  fontFamily: "'Fraunces', serif",
  fontSize: 24,
  color: "var(--text-heading)",
  margin: "16px 0 6px",
};

const body = {
  fontSize: 14,
  color: "var(--text-body)",
  margin: "0 0 20px",
  maxWidth: 320,
};

const homeLink = {
  padding: "12px 24px",
  borderRadius: 10,
  background: "var(--accent-primary)",
  color: "var(--accent-contrast)",
  fontWeight: 700,
  fontSize: 14,
  textDecoration: "none",
};
